/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Match_Help_ContainsInputs */



/**
* | output |
* | --- |
* | "Matches if the text contains the keyword anywhere" |
*
* @param {Compliance_Template_Match_Help_ContainsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_match_help_contains = /** @type {((inputs?: Compliance_Template_Match_Help_ContainsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Match_Help_ContainsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passt, wenn der Text das Schlüsselwort irgendwo enthält")
	return /** @type {LocalizedString} */ ("Matches if the text contains the keyword anywhere")
});